import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import axios from "axios";
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import SwipeableDrawer from "jd-library/SwipeableDrawer";
import historyHandler from "jd-library/historyHandler";
import {
  ProdList,
  ProdResultList,
  HeaderTitle,
} from "../add-edit-item/add-item/ProdList";
import styles from "../add-edit-item/add-item/add-item.scss";
import ItemListSlider from "../../common/Item-List-Slider/ItemListSlider";
import {
  updateEditProductDetail,
  getProductData,
  hideItemSearch,
  setSelectedType,
  setFromSeller,
  showNotFoundModal,
  showItemSearchSlider
} from "../../actions/products";
import { setSession } from '../../actions/index';
import { resetVariantData } from '../../actions/variants';
import { identifyAuditFlow, getBusinessTypes } from "../../utills";
import { updateBrandManufactureDetails } from "../../actions/productSpecification";
import { toggleAddProductSlider } from "../../actions/products"
import { scanBarcode } from "./appUtils/AppUtils";
import {toggleBarcodeScannerSecondary} from '../../actions/barcodeScanner';

const ItemSearchSlider = (props) => {
  const [itemCategorySlider, setItemCategorySlider] = useState(false);
  const [addItemSlider, toggleAddItemSlider] = useState(false);
  const [itemEditSlider, setItemEditSlider] = useState(false);
  const [searchLoader, toggleSearchLoader] = useState(false);
  const [itemCategory, setItemCategory] = useState("");
  const [bottomDrawer, setBottomDrawer] = useState(false);
  const [prodList, setProdList] = useState([]);
  const [barcodeSearch, setBarcodeSearch] = useState(false);
  let [itemSearchData, setItemSearchData] = useState([]);
  let selectTypeQuery = identifyAuditFlow({ query: true });
  const [searchKey, setSearchKey] = useState(props.searchKey || selectTypeQuery?.searchKey || "");
  let fromSeller = selectTypeQuery.fromSeller;
  const dispatch = useDispatch();
  let [pageNo, setPageNo] = useState(1);
  let axiosCall = useRef(null);
  const history = useHistory();
  const isIPhone = props.deviceData.isIphone;
  const [isScanned,updateStatus] = useState(false);

  const onSearchChange = (queryParams, toggleOldData, callback) => {
    if (barcodeSearch) {
      setBarcodeSearch(false);
    }
    toggleSearchLoader(true);
    if (!toggleOldData && axiosCall.current) {
      axiosCall.current.cancel();
    }
    axiosCall.current = axios.CancelToken.source();
    if (isNaN(queryParams.srchterm)) {
      axios
        .get("/vendorapis/products/product/fetchTemplateProductsBySearchTerm", {
          params: queryParams,
          cancelToken: axiosCall.current.token,
        })
        .then((res) => {
          if (res.data.length) {
            const data = res.data;
            let newData = [];
            data.map((item, index) => {
              newData[index] = {
                barcode: item.barcode,
                imagePath: item.image,
                id: item.id,
                productTemplateName: item.name,
                productTemplateNameSearch: item.name_srch,
                unitPerPiece: item.unitPerPiece,
                contentPerPiece: item.contentPerPiece,
                isTemplate: true,
              };
            });
            if (toggleOldData) {
              setItemSearchData(itemSearchData.concat(newData));
            } else {
              setItemSearchData(newData);
            }
          } else if (!toggleOldData) {
            setItemSearchData([]);
            setPageNo(1);
          }
          callback && callback(res.data.length == 0 ? false : true);
          toggleSearchLoader(false);
        });
    } else {
      axios
        .get("/vendorapis/products/product/fetchTemplateProductById", {
          params: { barcode: queryParams.srchterm , token: props.token,newProfile:props.newProfile},
          cancelToken: axiosCall.current.token,
        })
        .then((res) => {
          if (res?.data?.data?.length) {
            let dataList = res.data.data;
            let dataArr = [];
            dataList.map((data) => {
              let newData = {
                barcode: data.barcode,
                imagePath: data.productImages?data.productImages[0]:'',
                id: data.id,
                productTemplateName: data.productName,
                productTemplateNameSearch: data.productName,
                unitPerPiece: data.unitPerPiece,
                contentPerPiece: data.contentPerPiece,
                isTemplate: true,
                fromBarcode: true,
              };
              dataArr.push(newData);
            });
            setItemSearchData(dataArr);
          }
          toggleSearchLoader(false);
          console.log(res.data);
        });
    }
  };

  useEffect(() => {
    if(selectTypeQuery?.closeIframe == '1'){
      if (props?.hideSuggestedAutoServiceSlider){
        window.location.href = window.location.href.replace('/products/itemsearch','/products/add-omni');  
      }else{
        const iframeEle = parent?.document?.getElementById('omniIframe');
        if (iframeEle) iframeEle.style.visibility = 'unset';
        parent.document.body.style.overflow = 'hidden';
        parent?.Utills?.Loader?.hide({loaderType: 'spinner'});
        selectTypeQuery?.fromWalkthrough == 'true' && props.setSession({fromWalkthrough: true});
      }
      if (selectTypeQuery?.selectedProductType == 'service'){
        props.setSelectedType({selectedCategoryType: selectTypeQuery?.selectedProductType})
        props.showItemSearchSlider(selectTypeQuery?.selectedProductType)
      }
    }
    if(searchKey) {
      itemOnChange(searchKey)
    }
  },[])
  
  useEffect(()=>{
    if(fromSeller === "true"){
      dispatch(setFromSeller({fromSellerDashboard:true}));
    }
    dispatch(toggleAddProductSlider({isAddProductSlider:true}))
  },[])

  const getProdByBarcode = (barcode) => {
    toggleSearchLoader(true);
    let queryParams = {
      barcode: barcode,
      token: props.token,
      newProfile :props.newProfile
    };
    axios
      .get("/vendorapis/products/product/fetchTemplateProductById", {
        params: queryParams
      })
      .then((res) => {
        if (res.data.data.length) {
          let dataList = res.data.data;
          let dataArr = [];
          dataList.map((data) => {
            let newData = {
              barcode: data.barcode,
              imagePath: data.productImages?data.productImages[0]:'',
              id: data.id,
              productTemplateName: data.productName,
              productTemplateNameSearch: data.productName,
              unitPerPiece: data.unitPerPiece,
              contentPerPiece: data.contentPerPiece,
              isTemplate: true,
              fromBarcode: true,
            };
            dataArr.push(newData);
          });
          if(dataArr.length == 1) {
            onItemClick(dataArr[0]);
          }else if(props.isSourceJustdial && dataArr.length > 1){
            setBottomDrawer(true);
          }
            setItemSearchData(dataArr);
        }else {
          props.showNotFoundModal({
            barcode,
            closeCB: () => setSearchKey('')
          });
        }
        toggleSearchLoader(false);
      });
  };

  const getColumnName = (str) => {
    return /^\d+$/.test(str) ? "barcode" : "productName";
  };

  const getQueryParams = (query, isOnlyCategories) => {
    let data = {
      limit: 10,
      page: 1,
      srchterm: query,
      type: 1,
      token: props.token
    };
    if (props.showItemSearchProdSer == 'service'){
      data.service = 1
    }
    return data;
  };

  const infiniteScrollCallback = (callback) => {
    let query = { ...getQueryParams(searchKey, false), page: ++pageNo };
    // if (props.itemInfo.category) {
    //     query = { ...query, isOnlyCategories: false, puvId: props.itemInfo.category }
    // }
    onSearchChange(query, true, callback);
    setPageNo(pageNo);
  };

  const onItemClick = (item) => {
    console.log(item);
    if (item.id) {
      if (item.id == "Create New Product") {
        // toggleAddItemSlider(false);
        setTimeout(() => {
          props.updateEditProductDetail([
            {
              key: "productName",
              value: searchKey,
            },
            {
              key: "imageUrlArr",
              value: [],
            },
            {
              key: "videoUrlArr",
              value: [],
            },
            {
              key: "videoUrlIds",
              value: [],
            },
            {
              key: "productId",
              value: "ADD_PRODUCT",
            },
            {
              key: "categoryType",
              value: props.showItemSearchProdSer
            },
            {
              key: "bizSuggestion",
              value: {
                data: getBusinessTypes(),
              },
            },
          ]);
          props.setSelectedType({selectedCategoryType:props.showItemSearchProdSer})
          setTimeout(() => {
            props.getProductData({
              productId: "ADD_PRODUCT",
              isTemp: true,
            });
          }, 100);
          if (props.isMobile) {
            props.resetVariantData(); // tiga 1137
            const addUrlPrefix=props.viaOmni?"/products/add-omni":"/products/add"
            history.push(`${addUrlPrefix}?isTemp=true${props.showItemSearchProdSer == 'service' ? '&selectedProductType=service' : ''}`)
            return;
          }
          historyHandler.closeAll();
        });
      } else {
        let params = item.fromBarcode
          ? {
              barcode: item.barcode.toString(),
            }
          : {
              productId: item.id,
            };
        params.token = props.token;
        params.newProfile = props.newProfile;
        if (props.showItemSearchProdSer == 'service'){
          params.service = 1
        }
        axios
          .get("/vendorapis/products/product/fetchTemplateProductById", {
            params: params,
            cancelToken: axiosCall?.current?.token,
          })
          .then((res) => {
            let data = res?.data?.data?.[0];
            console.log(data);
            dispatch(setSession({
              businessType: data?.businessType || ""
            }));
            if (data?.productExist) {
             props.updateBrandManufactureDetails({
                detailsSpecification: data?.detailsSpecification
             })
              if (props?.isMobile) {
                let editUrl = props.viaOmni ? '/products/edit-omni/' : '/products/edit/';
                history.push(editUrl + data.productId);
                return;
              }
              let dataToSend = {
                productId: data?.objectionableId ? '_'+data.objectionableId+'_OBJECTION': data.productId,
                id: data?.objectionableId ? data.objectionableId : data.id,
                isObjectionable: data?.objectionableId
              }
              props.getProductData({
                ...dataToSend
              });
              historyHandler.closeAll();
            } else {
              let dataArr = [];
              let complianceCount = 0;
              Object.keys(data).map((cur, index) => {
                dataArr.push({
                  key: cur,
                  value: data[cur],
                });
              });
              Object.keys(data.compliance).map(cur => {
                if(!['hsn','tax_rate','importer','importers_detail','country_of_origin','manufacturer','manufactured_details','price','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date','brand'].includes(cur.toLowerCase()) && !data.compliance[cur]){
                  complianceCount ++;
                }

              })
              let imgUrlArr = data.productImages?data.productImages.map((cur) => {
                return {
                  finalImageSrc: cur,
                  imgURL: cur,
                };
              }):[];
              dataArr = dataArr.concat([
                {
                  key: "productId",
                  value: "ADD_PRODUCT",
                },
                {
                  key: "parentId",
                  value: item.id,
                },
                {
                  key: "isTempProd",
                  value: (data?.type == 'SERVICE')  ? false : true,
                },
                {
                  key: "imageUrlArr",
                  value: imgUrlArr,
                },
                {
                  key: "bizSuggestion",
                  value: {
                    data: getBusinessTypes(),
                    selected: data.businessType,
                    bizType: data.businessType
                  },
                },
                // {
                //   key: "toggleBiz",
                //   value: props.businessType ? false : true,
                // },
                {
                  key: "sellingOnlinePrice",
                  value: data.sellingPrice || '',
                },
                {
                  key : 'salesTaxJson',
                  value: data.SalesTax? JSON.parse(data.SalesTax):""
                },
                {
                  key: 'salesTax',
                  value: data.SalesTax? JSON.parse(data.SalesTax):""
                },
                {
                  key: 'hsnPresent',
                  value: data.hsnSacNo
                },
                {
                key: 'taxPresent',
                value: data.SalesTax && String(JSON.parse(data.SalesTax)?.gstRate)?.trim().length ? data.SalesTax : ''
                },
                {
                  key: 'hasCompliance',
                  value: complianceCount
                },
                {
                  key: 'isManufacturerMand',
                  value: Number(data.compliance_flag?.manufacturer_flag)
                },
                {
                  key: 'mrp',
                  value: data.mrp || ''
                },{
                  key: 'categoryType',
					        value: data?.type.toLowerCase()
                }
              ]);
              setTimeout(() => {
                props.updateEditProductDetail(dataArr);
                if (props.isMobile) {
                  const addUrlPrefix=props.viaOmni?"/products/add-omni":"/products/add"                  
                  history.push(`${addUrlPrefix}?isTemp=true&selectedProductType=${data?.type.toLowerCase()}`)
                  return;
                }
              });
              props.updateBrandManufactureDetails({
                detailsSpecification: data.detailsSpecification
             })
              setTimeout(() => {
                props.getProductData({
                  productId: "ADD_PRODUCT",
                  isTemp: true,
                  id: data.id
                });
              }, 100);
              if (!props.isMobile) {
                historyHandler.closeAll();
              }
            }
          });
      }
    } else {
      console.log('Not found : due to backend ')
    }
  };

  const itemOnChange = (queryStr) => {
    updateStatus(false);
    setSearchKey(queryStr);
    if (!queryStr && barcodeSearch) setBarcodeSearch(false);
    if (queryStr.length > 2) {
      let query;
      if (props.itemInfo.category) {
        query = {
          ...getQueryParams(queryStr, false),
          puvId: props.itemInfo.category,
        };
      } else {
        query = getQueryParams(queryStr, true);
      }
      onSearchChange(query);
    } else {
      setItemSearchData([]);
      setPageNo(1);
    }
  };

  const onHeaderIconClick = () => {
    setItemCategorySlider(false);
    toggleAddItemSlider(false);
  };

  const onCategoryHidden = (categoryData) => {
    let query;
    if (categoryData) {
      setItemCategory(categoryData.catName);
      if (categoryData.catName != "All Categories") {
        props.updateItemInfo({
          productGroupBreadCrumbList: [categoryData.categoryPath],
          itemType: categoryData.catName,
          category: categoryData.id,
        });
        query = { ...getQueryParams(searchKey, false), puvId: categoryData.id };
      } else {
        props.updateItemInfo({
          productGroupBreadCrumbList: [],
          itemType: "",
          category: "",
        });
        query = getQueryParams(searchKey, false);
      }
      if (searchKey) {
        onSearchChange(query);
      }
    }
    setItemCategorySlider(false);
    if (props.onFlowComplete) {
      historyHandler.closeCurrent();
    } else {
      historyHandler.closeAll();
    }
  };

  const scanBarcodeFunc = (options) => {
    updateStatus(true);
    setTimeout(() => {
    //   props.toggleBarcodeScannerSecondary({
    //     showScannerSecond: true,
    //     onDetectedCB: (data) => {
    //       setSearchKey(data);
    //       setBarcodeSearch(true);
    //       getProdByBarcode(data);
    //     },
    //     onFailedCB: () => console.log('error')
    // })
      scanBarcode({
        callback: (data) => {
          setSearchKey(data);
          setBarcodeSearch(true);
          getProdByBarcode(data);
          options.cb && options.cb();
        },
      });
    }, 300);
  };

  const itemListData = {
    header: {
      raised: false,
      title: "",
    },
    infiniteScrollCB: infiniteScrollCallback,
    isBarcodeSearch: '',
    isScanned,
    showItemSearchProdSer: props.showItemSearchProdSer,
    showOnlySearch: true,
    fromAddEditItemSearch: true,
    noRsltBarcode: barcodeSearch && !itemSearchData.length && !searchLoader,
    scanBarcodeFunc: scanBarcodeFunc,
    noAutoFocus: itemEditSlider,
    search: {
      class: "search-text-padding",
      leftIcon: "icon-Product",
      placeholder: `Enter ${props.showItemSearchProdSer == 'service' ? 'Service' : 'Product'} Name`,
      loader: searchLoader,
      onChange: itemOnChange,
      minLength: 2,
      maxLength: 100,
      value: searchKey,
      hideScanner: itemCategorySlider || itemEditSlider,
    },
    subHeader: !barcodeSearch
      ? {
          class: "create-new-item",
          text: `Create New ${props.showItemSearchProdSer == 'service' ? 'Service' : 'Product'}`,
          onClick: (e) => onItemClick({ id: 'Create New Product' }),
        }
      : null,
    onHidden: (fromSearch) => {
      if (props.onFlowComplete) {
        props.onFlowComplete();
      } else {
        if (!props.isMobile) {
          props.hideItemSearch();
        }
      }
    },
    autoSuggestion: {
      data: bottomDrawer?[]:itemSearchData,
      renderListItem: (item, index) => {
        const itemData = {
          icon: "icon-HDRsearch",
          onItemClick: (e) => onItemClick(e),
        };
        return (
          <ProdResultList
            index={index}
            item={item}
            searchKey={searchKey}
            showNoImage={!item.imagePath}
            itemData={itemData}
          />
        );
      },
    },
    fromSeller,
    customBack: selectTypeQuery?.closeIframe == '1' ? () => {
      let ele = parent?.document.getElementById('omniIframe');
      parent.document.body.style.overflow = 'unset';
      if(ele?.parentNode && ele?.parentNode?.children && ele?.parentNode?.children?.length){
        ele.parentNode.removeChild(ele);
      }
    } : null
  };

  useLayoutEffect(() => {
    if (props.location.pathname.indexOf("edit-item") != -1) {
      if (props.itemInfo.isEdit) {
        setItemEditSlider(true);
      } else {
        let itemId = props.match.params.itemId;
        props.fetchDataAndEdit({
          itemId: itemId,
          cb: () => {
            setItemEditSlider(true);
          },
        });
      }
    } else if (props.redirectedFrom == "photos") {
      setItemEditSlider(true);
    } else {
      // props.resetItemInfo();
    }
  }, []);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (props.location.pathname.indexOf("edit-item") == -1) {
        if (addItemSlider && !itemEditSlider) {
          let mainInput = document.querySelector(".search-text-padding");
          mainInput && mainInput.focus();
        } else if (!itemCategorySlider && !itemEditSlider && !addItemSlider) {
          toggleAddItemSlider(true);
        }
      }
    });
  }, [addItemSlider, itemCategorySlider, itemEditSlider]);

  if(props.hideSuggestedAutoServiceSlider && selectTypeQuery.closeIframe == 1) {
    return null;
  }

  return (
    <div
      className={
        styles["add-item-slider"] + (isIPhone ? " " + styles["jd-iphone"] : "")
      }
    >
      {addItemSlider && (
        <div className={styles["select-slider"]}>
          <ItemListSlider {...itemListData} />
        </div>
      )}
      {bottomDrawer && (
        <div className={styles["bottom-drawer"]}>
          <SwipeableDrawer onHidden={() => {
            setBottomDrawer(false);
            setSearchKey('');
            setItemSearchData([]);
          }}>
            <div className={styles["popup-header"]}>
              <div>SELECT ITEM</div>
              <div
                className={"icon-HDRcross " + styles["font11"]}
                onClick={() => {
                  setBottomDrawer(false);
                  setSearchKey('');
                  setItemSearchData([]);
                }}
              ></div>
            </div>
            {itemSearchData.map((item, index) => (
              <ProdList
                item={item}
                isLast={index == itemSearchData.length - 1}
                onClick={() => {
                  setBottomDrawer(false);
                  setSearchKey('');
                  setItemSearchData([]);
                  onItemClick(item);
                }}
              />
            ))}
          </SwipeableDrawer>
        </div>
      )}
    </div>
  );
  
};
const mapStateToProps = (state) => {
  return {
    itemInfo: state.items.itemInfo,
    supplierId: state.session.supplierId,
    redirectedFrom: state.products.redirectedFrom,
    deviceData: state.deviceData,
    token: state.session.token,
    isMobile: state.library.deviceData.isMobile,
    businessType: state.session.businessType,
		isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS,
    newProfile:state.session.newProfile,
    viaOmni:state.session.viaOmni,
    showItemSearchProdSer: state.products.showItemSearchProdSer,
    hideSuggestedAutoServiceSlider: state.session?.hideSuggestedAutoServiceSlider

  };
};

export default connect(mapStateToProps, {
  updateEditProductDetail,
  getProductData,
  hideItemSearch,
  setSelectedType,
  resetVariantData,
  updateBrandManufactureDetails,
  showNotFoundModal,
  toggleBarcodeScannerSecondary,
  showItemSearchSlider,
  setSession
})(withRouter(ItemSearchSlider));
